export default __webpack_public_path__ + "static/scientist8-b1832b5e364f545eb253fd66bbf2c2ec.png";